import React, { Component } from 'react';
import Link from 'gatsby-link';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

//<Link className="btn" to={link} title={text}>{text}</Link>
//<OutboundLink className="btn" href={link} title={text}>{text}</OutboundLink>
const BicenturyLink = ({text, link, type, className, lang, onClick}) => {
	let inner_link = link;
	if ("undefined" === typeof(type) || type === 'internal') {
		if ("undefined" != typeof(lang) && lang) {
			inner_link = `/${lang}${link}`;
		}
		return (
			<Link className={className} to={inner_link} title={text} onClick={onClick}>{text}</Link>
		);
	} else if (type === 'external') {
		return (
			<OutboundLink className={className} href={link} target='_blank'>{text}</OutboundLink>
		);
	} else if (type==='cookie') {
		return (
			<Link className={className} to={inner_link} title={text} onClick={onClick}>{text}</Link>
		);	
	} else {
		return (
			<OutboundLink className={className} href={link}>{text}</OutboundLink>
		);
	}
}

export default BicenturyLink;



// WEBPACK FOOTER //
// ./src/components/link/index.js